import { request } from '@remote/api/request'
import { IDeviceInfo } from '@remote/type/device'
import { IErrorRes } from '@remote/type'
import { IRes, IRequestCommonResponse } from './index.d'

type IUpdateDeviceNameParams = Pick<IDeviceInfo, 'cookie' | 'device_id'>
type IUpdateDeviceNameReturn = Pick<IDeviceInfo, 'cookie' | 'device_id' | 'nickname'>
// 更新设备名称
export const updateDeviceName = (deviceInfo: IUpdateDeviceNameParams, name: string): Promise<[IErrorRes, IRes<IUpdateDeviceNameReturn>]> => {
  const { cookie, device_id } = deviceInfo
  const url = '/api/v1/device/update_device_name'
  const params = {
    cookie,
    device_id,
    name,
  }
  return request(url, params, { apiEnv: 'heziProduction', method: 'GET' })
}

export const getDeviceList = (): Promise<[IErrorRes, IRes<{ list: IDeviceInfo[] }>]> => {
  const url = '/api/v1/device/get_device_list'
  return request(url, {}, { apiEnv: 'heziProduction', method: 'GET' })
}

/** 获取设备信息 */
export function getDeviceInfo (deviceId: string) {
  return getDeviceList().then(response => {
    const [err, result] = response
    if (!err && result?.ret === 0) {
      const target = result.data.list?.find(item => item.device_id === deviceId)
      return target
    }
    return undefined
  })
}

/** 查询设备的MQTT连接情况 */
export async function checkDeviceMQTTReady (deviceId: string, traceId = '') {
  const url = '/api/v1/device/get_app_mqtt_status_by_mid'

  return request(url, { device_id: deviceId }, {
    apiEnv: 'heziProduction',
    method: 'GET',
    headers: {
      'X-Trace-Id': traceId,
    },
  }).then((response: IRequestCommonResponse<{ online_nums: number }>) => {
    const [err, result] = response
    if (err) {
      const { error, error_description, msg } = err
      const errMessage = `${msg}(#${error}: ${error_description})`
      throw new Error(errMessage)
    }
    const { code, msg, data } = result
    if (code !== 200 || !data) {
      throw new Error(msg || '获取xos包信息失败')
    }
    
    return data.online_nums >= 4
  })
}
